import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'tranquilitydentalwellness',
  tokenName: 'tranquilitydentalwellnessSubscriberToken',
  globalClass: 'tranquilitydentalwellness-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  heroLocaleColor: 'secondary',
  headerProps: {
    enable: false,
  },
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      secondaryButtonProps: {
        to: '/login',
        color: 'primary',
      },
      background: '/images/home-images/home-banner-img.webp',
      verticalAlignImage: 'bottom',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'left',
      alignCard: 'left',
    },
    subscriptionSection: {
      tabVariant: 2,
      loaderColor: 'secondary',
      cardVariant: 1,
      carouselResponsiveItems: {
        desktop: 3,
      },
      planCardProps: {
        buttonProps: {
          customSpace: 12,
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.webp',
    },
    testimonialSection: {
      variant: 2,
      centerMode: true,
      avatarStyle: 'top',
      subtitleVariant: 'body1',
      sectionClass: 'section-container',
      messageType: 'h6',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    enableFooterbar: true,
    contactSection: 'contactDetails',
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
    moreSavingsButtonProps: {
      variant: 'contained',
      color: 'primary',
    },
  },
  findProviderSection: {},
  faqSection: {
    heroProps: {
      secondaryButtonProps: {
        variant: 'outlined',
        color: 'primary',
      },
    },
  },
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: false,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
};

export default config;
